export default __webpack_public_path__ + "static/media/creativetim-white-slim.c9b2f68e.png";